export const checklist = [
  { value: "windowSchedule", label: "Window Schedule" },
  { value: "doorSchedule", label: "Door Schedule" },
  { value: "doorHardwareSchedule", label: "Door Hardware Schedule" },
  { value: "finishesSchedule", label: "Finishes Schedule" },
  { value: "energyEfficiencyReport", label: "Energy Efficiency Report" },
  { value: "acousticReport", label: "Acoustic Report" },
];
